<template>
  <div v-bind="$attrs">
    <el-checkbox :class="itemClass" v-for="checkbox in checkboxs" :key="checkbox.label" :value="value" :checked="checked" :label="checkbox.label" v-on="$listeners">
      <slot />
    </el-checkbox>
  </div>
</template>
<script>
import { computed, defineComponent, ref } from "@nuxtjs/composition-api";
import { uniqueId } from "lodash";

export default defineComponent({
	name: "IndexCheckbox",
	props: {
		value: {
			type: Array,
			value: () => []
		},
		label: {
			type: [String, Number, Boolean]
		},
		itemClass: String,
		options: Array
	},
	setup(props) {
		const checked = computed(() => [].includes(props.label));
		const checkboxs = ref([]);
		let i = 0;
		while (i < 2) {
			checkboxs.value.push({
				label: uniqueId("checkboxItem-")
			});
			i++;
		}
		return {
			checkboxs,
			checked
		};
	}
});
</script>
<style lang="">


</style>